import types from './types';

const INITIAL_STATE: any = [];

const breadcrumbReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.UPDATE_BREADCRUMB:
      return action.payload;

    default:
      return state;
  }
};

export default breadcrumbReducer;
